import type {
  User,
  Post,
  PhotoPost,
  VideoPost,
  TextPost,
  ArticlePost,
  Comment,
  Story,
} from "./types"

export const mockUsers: User[] = [
  {
    id: "1",
    username: "alex_chen",
    displayName: "Alex Chen",
    email: "alex@example.com",
    avatar: "/placeholder-t80at.png",
    bio: "Street photographer & visual storyteller 📸",
    website: "alexchen.photo",
    isVerified: true,
    followerCount: 12500,
    followingCount: 890,
    postCount: 247,
    createdAt: new Date("2023-01-15"),
  },
  {
    id: "2",
    username: "maya_writes",
    displayName: "Maya Rodriguez",
    email: "maya@example.com",
    avatar: "/latina-writer-glasses.png",
    bio: "Writer, dreamer, coffee enthusiast ☕️\nSharing stories that matter",
    isVerified: false,
    followerCount: 3200,
    followingCount: 456,
    postCount: 89,
    createdAt: new Date("2023-03-22"),
  },
  {
    id: "3",
    username: "david_travels",
    displayName: "David Kim",
    email: "david@example.com",
    avatar: "/asian-man-backpack-portrait.png",
    bio: "🌍 Digital nomad exploring the world\n📍 Currently in Bali",
    isVerified: false,
    followerCount: 8900,
    followingCount: 1200,
    postCount: 156,
    createdAt: new Date("2022-11-08"),
  },
  {
    id: "4",
    username: "sarah_creates",
    displayName: "Sarah Johnson",
    email: "sarah@example.com",
    avatar: "/blonde-artist-portrait.png",
    bio: "Digital artist & UI designer\nCreating beauty in pixels ✨",
    isVerified: true,
    followerCount: 15600,
    followingCount: 678,
    postCount: 312,
    createdAt: new Date("2022-08-14"),
  },
]

export const mockPosts: Post[] = [
  {
    id: "1",
    userId: "1",
    user: mockUsers[0],
    type: "photo",
    images: [
      {
        url: "/urban-sunset-street.png",
        alt: "Golden hour street scene with silhouettes",
        caption:
          "The main street during golden hour - my favorite time to shoot",
        aspectRatio: 1,
      },
      {
        url: "/bw-street-musician.png",
        alt: "Street musician playing guitar",
        caption: "This musician's passion was infectious - had to capture it",
        aspectRatio: 3 / 4,
      },
      {
        url: "/colorful-abstract-palette.png",
        alt: "Colorful street art mural",
        caption: "Found this incredible mural just around the corner",
        aspectRatio: 16 / 9,
      },
    ],
    caption:
      "A day exploring the city streets. Sometimes the best shots happen when you least expect them. 🌅",
    likeCount: 1247,
    commentCount: 89,
    isLiked: false,
    createdAt: new Date("2024-01-10T18:30:00"),
    updatedAt: new Date("2024-01-10T18:30:00"),
  } as PhotoPost,
  {
    id: "2",
    userId: "2",
    user: mockUsers[1],
    type: "text",
    content:
      "Sometimes the words we don't say carry more weight than the ones we do. In the silence between heartbeats, stories are born.",
    backgroundColor: "#1a1a2e",
    textColor: "#ffffff",
    likeCount: 892,
    commentCount: 156,
    isLiked: true,
    createdAt: new Date("2024-01-09T14:22:00"),
    updatedAt: new Date("2024-01-09T14:22:00"),
  } as TextPost,
  {
    id: "3",
    userId: "3",
    user: mockUsers[2],
    type: "video",
    videoUrl: "/placeholder.mp4",
    thumbnailUrl: "/bali-rice-terraces-drone.png",
    duration: 45,
    aspectRatio: 16 / 9,
    caption:
      "Sunrise over the rice terraces in Bali. Nature's architecture at its finest 🌾",
    likeCount: 2156,
    commentCount: 234,
    isLiked: false,
    createdAt: new Date("2024-01-08T06:15:00"),
    updatedAt: new Date("2024-01-08T06:15:00"),
  } as VideoPost,
  {
    id: "4",
    userId: "4",
    user: mockUsers[3],
    type: "article",
    title: "The Psychology of Color in Digital Design",
    content:
      "Color is more than just a visual element—it's a powerful tool that can evoke emotions, influence decisions, and create memorable experiences. In digital design, understanding color psychology is crucial for creating interfaces that not only look beautiful but also function effectively.\n\nWarm colors like red, orange, and yellow tend to create feelings of energy, warmth, and excitement. They can grab attention and encourage action, making them perfect for call-to-action buttons and important notifications.\n\nCool colors such as blue, green, and purple often evoke feelings of calm, trust, and professionalism. This is why many tech companies and financial institutions use blue in their branding—it communicates reliability and trustworthiness.",
    coverImage: "/colorful-abstract-palette.png",
    readTime: 5,
    tags: ["design", "psychology", "color theory", "ui/ux"],
    likeCount: 567,
    commentCount: 78,
    isLiked: true,
    createdAt: new Date("2024-01-07T10:00:00"),
    updatedAt: new Date("2024-01-07T10:00:00"),
  } as ArticlePost,
  {
    id: "5",
    userId: "1",
    user: mockUsers[0],
    type: "photo",
    imageUrl: "/urban-sunset-street.png",
    imageAlt: "Golden hour street scene with silhouettes",
    aspectRatio: 1,
    caption:
      "Golden hour magic in the city streets. Sometimes the best shots happen when you least expect them. 🌅",
    likeCount: 934,
    commentCount: 67,
    isLiked: false,
    createdAt: new Date("2024-01-06T16:45:00"),
    updatedAt: new Date("2024-01-06T16:45:00"),
  } as PhotoPost,
  {
    id: "6",
    userId: "2",
    user: mockUsers[1],
    type: "text",
    content:
      "Coffee shop thoughts: Why do we always assume that busy equals productive? Sometimes the most important work happens in the quiet moments.",
    backgroundColor: "#8B4513",
    textColor: "#F5DEB3",
    likeCount: 445,
    commentCount: 89,
    isLiked: false,
    createdAt: new Date("2024-01-05T09:30:00"),
    updatedAt: new Date("2024-01-05T09:30:00"),
  } as TextPost,
  {
    id: "7",
    userId: "4",
    user: mockUsers[3],
    type: "photo",
    images: [
      {
        url: "/colorful-abstract-palette.png",
        alt: "Digital art workspace setup",
        caption: "My creative workspace where the magic happens",
        aspectRatio: 16 / 9,
      },
      {
        url: "/blonde-artist-portrait.png",
        alt: "Artist working on tablet",
        caption: "Deep in the creative flow",
        aspectRatio: 1,
      },
    ],
    caption: "Behind the scenes of my latest digital art project ✨",
    likeCount: 892,
    commentCount: 134,
    isLiked: true,
    createdAt: new Date("2024-01-04T11:20:00"),
    updatedAt: new Date("2024-01-04T11:20:00"),
  } as PhotoPost,
  {
    id: "8",
    userId: "3",
    user: mockUsers[2],
    type: "photo",
    images: [
      {
        url: "/bali-rice-terraces-drone.png",
        alt: "Aerial view of rice terraces",
        caption: "The incredible rice terraces from above",
        aspectRatio: 16 / 9,
      },
      {
        url: "/asian-man-backpack-portrait.png",
        alt: "Traveler with backpack",
        caption: "Ready for another adventure",
        aspectRatio: 3 / 4,
      },
      {
        url: "/urban-sunset-street.png",
        alt: "Local market scene",
        caption: "The vibrant local markets are always full of life",
        aspectRatio: 4 / 3,
      },
      {
        url: "/colorful-abstract-palette.png",
        alt: "Traditional Balinese temple",
        caption: "The intricate details of Balinese architecture",
        aspectRatio: 1,
      },
    ],
    caption:
      "My Bali adventure continues! Every corner of this island tells a story 🌴",
    likeCount: 2341,
    commentCount: 187,
    isLiked: false,
    createdAt: new Date("2024-01-03T07:45:00"),
    updatedAt: new Date("2024-01-03T07:45:00"),
  } as PhotoPost,
]

export const mockComments: Comment[] = [
  {
    id: "1",
    postId: "1",
    userId: "2",
    user: mockUsers[1],
    content: "This is absolutely stunning! The lighting is perfect 🔥",
    likeCount: 23,
    isLiked: false,
    createdAt: new Date("2024-01-10T19:15:00"),
  },
  {
    id: "2",
    postId: "1",
    userId: "4",
    user: mockUsers[3],
    content:
      "Your street photography always inspires me. What camera settings did you use?",
    likeCount: 12,
    isLiked: true,
    createdAt: new Date("2024-01-10T20:22:00"),
  },
  {
    id: "3",
    postId: "2",
    userId: "3",
    user: mockUsers[2],
    content: "This hits different. Your words always make me think.",
    likeCount: 8,
    isLiked: false,
    createdAt: new Date("2024-01-09T15:30:00"),
  },
]

export const mockStories: Story[] = [
  {
    id: "1",
    userId: "1",
    user: mockUsers[0],
    imageUrl: "/behind-the-scenes-photography.png",
    duration: 15,
    viewCount: 234,
    isViewed: false,
    createdAt: new Date("2024-01-10T12:00:00"),
    expiresAt: new Date("2024-01-11T12:00:00"),
  },
  {
    id: "2",
    userId: "3",
    user: mockUsers[2],
    videoUrl: "/placeholder.mp4",
    duration: 10,
    viewCount: 156,
    isViewed: true,
    createdAt: new Date("2024-01-10T08:30:00"),
    expiresAt: new Date("2024-01-11T08:30:00"),
  },
  {
    id: "3",
    userId: "4",
    user: mockUsers[3],
    text: "Working on something exciting! 🎨",
    backgroundColor: "#FF6B6B",
    duration: 5,
    viewCount: 89,
    isViewed: false,
    createdAt: new Date("2024-01-10T14:20:00"),
    expiresAt: new Date("2024-01-11T14:20:00"),
  },
]

// Helper functions for mock data manipulation
export const getCurrentUser = (): User => mockUsers[0]

export const getPostsByUser = (userId: string): Post[] => {
  return mockPosts.filter(post => post.userId === userId)
}

export const getCommentsByPost = (postId: string): Comment[] => {
  return mockComments.filter(comment => comment.postId === postId)
}

export const getStoriesByUser = (userId: string): Story[] => {
  return mockStories.filter(story => story.userId === userId)
}

export const getActiveStories = (): Story[] => {
  const now = new Date()
  return mockStories.filter(story => story.expiresAt > now)
}

// Add more diverse users for profile examples
export const additionalMockUsers: User[] = [
  {
    id: "5",
    username: "luna_aesthetic",
    displayName: "Luna Park",
    email: "luna@example.com",
    avatar: "/aesthetic-purple-hair-girl.png",
    bio: "Aesthetic curator & mood board creator 🌙\nFinding beauty in the everyday",
    isVerified: false,
    followerCount: 45600,
    followingCount: 234,
    postCount: 1247,
    createdAt: new Date("2022-05-12"),
  },
  {
    id: "6",
    username: "marco_minimalist",
    displayName: "Marco Silva",
    email: "marco@example.com",
    avatar: "/minimalist-photographer-man.png",
    bio: "Less is more 🤍\nMinimalist photographer & architect",
    website: "marcosilva.design",
    isVerified: true,
    followerCount: 78900,
    followingCount: 89,
    postCount: 456,
    createdAt: new Date("2021-09-03"),
  },
]

// Generate more diverse posts for different users
export const generateUserPosts = (userId: string, count: number): Post[] => {
  const user = [...mockUsers, ...additionalMockUsers].find(u => u.id === userId)
  if (!user) return []

  const postTypes = ["photo", "text", "article"] as const
  const posts: Post[] = []

  for (let i = 0; i < count; i++) {
    const type = postTypes[Math.floor(Math.random() * postTypes.length)]
    const basePost = {
      id: `${userId}-${i}`,
      userId,
      user,
      likeCount: Math.floor(Math.random() * 1000) + 50,
      commentCount: Math.floor(Math.random() * 100) + 5,
      isLiked: Math.random() > 0.7,
      createdAt: new Date(
        Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000,
      ),
      updatedAt: new Date(
        Date.now() - Math.random() * 30 * 24 * 60 * 60 * 1000,
      ),
    }

    if (type === "photo") {
      posts.push({
        ...basePost,
        type: "photo",
        imageUrl: `/placeholder.svg?height=${Math.random() > 0.5 ? 400 : 600}&width=${Math.random() > 0.5 ? 400 : 600}&query=${user.username} photo ${i}`,
        aspectRatio: [1, 3 / 4, 4 / 3, 16 / 9][Math.floor(Math.random() * 4)],
        caption: `Beautiful moment captured ${i + 1}`,
      } as PhotoPost)
    }
  }

  return posts
}
